import { FunctionComponent, SVGProps, useId } from 'react'

export const Logo: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => {
  const paint0 = useId()
  const paint1 = useId()
  const paint2 = useId()
  const paint3 = useId()
  return (
    <svg
      width="62"
      height="57"
      viewBox="0 0 62 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.4248 17.6389C24.4469 16.6395 27.6152 16.1231 30.7997 16.0897C30.8485 16.0897 30.8972 16.0897 30.9459 16.0897C32.1483 16.0897 33.3506 16.5726 34.2605 17.5052L40.6786 24.0833C41.5235 24.9493 41.9785 26.0484 42.0598 27.1642C41.9784 23.8834 41.3934 20.6526 40.3534 17.555C38.5335 12.1591 35.3163 7.24634 30.848 3.44939C30.3281 2.99975 29.7919 2.56677 29.2232 2.16709L20.0432 2.1674C17.7686 2.16747 15.6564 3.41659 14.5191 5.43175L4.26738 23.6348L3.66625 24.7174C2.52898 26.7325 2.52906 29.2306 3.66647 31.2457L4.05644 31.9285C4.95001 30.363 5.94108 28.9141 7.02963 27.5651C10.8964 22.8352 15.9169 19.4543 21.4248 17.6389Z"
        fill={`url(#${paint0})`}
        stroke="#284162"
      />
      <path
        d="M21.1799 37.3905C20.2212 34.2596 19.7499 30.9788 19.766 27.6647L19.766 27.648C19.766 27.5315 19.766 27.4149 19.766 27.2983L19.766 27.2817C19.8147 26.1159 20.2859 24.9834 21.147 24.1007L27.5646 17.5222C28.4582 16.6062 29.628 16.1399 30.7979 16.1065C27.5971 16.1233 24.445 16.6563 21.423 17.6557C15.915 19.4711 10.8946 22.852 7.04403 27.6152C5.95548 28.9642 4.96441 30.4131 4.07084 31.9786L14.5513 50.5807C15.6887 52.5958 17.7847 53.8447 20.0756 53.8447L32.7488 53.8443C32.1477 53.3946 31.5627 52.945 30.994 52.462C26.2496 48.4153 22.9186 43.1528 21.1799 37.3905Z"
        fill={`url(#${paint1})`}
        stroke="#284162"
      />
      <path
        d="M57.5011 23.5808C56.6888 24.9631 55.7789 26.2621 54.8041 27.4779C51.0185 32.1411 46.1118 35.4887 40.7176 37.3375C37.5981 38.4034 34.3323 38.9531 31.034 38.9865C30.9853 38.9865 30.9366 38.9866 30.8878 38.9866C29.6855 38.9866 28.4831 38.5037 27.5732 37.5711L21.1551 30.993C20.2615 30.077 19.8065 28.8946 19.774 27.6956C19.7578 31.0097 20.2291 34.2905 21.1879 37.4214C22.9266 43.1836 26.2738 48.4628 31.002 52.4762C31.5707 52.9592 32.1556 53.4255 32.7568 53.8584L41.8068 53.8582C44.0815 53.8581 46.1936 52.609 47.3309 50.5938L57.8588 31.9077L58.2 31.3082C59.3373 29.293 59.3372 26.7949 58.1998 24.7798L57.5011 23.5808Z"
        fill={`url(#${paint2})`}
        stroke="#284162"
      />
      <path
        d="M40.3718 17.5901C41.4117 20.671 41.9968 23.9185 42.0781 27.1993C42.0944 27.3659 42.0944 27.5324 42.0944 27.6989C42.0619 28.8814 41.5908 30.0638 40.7134 30.9798L34.2958 37.5583C33.4022 38.4743 32.2324 38.9407 31.0625 38.974C34.3608 38.9572 37.6266 38.3909 40.7461 37.325C46.1241 35.4928 51.047 32.1452 54.8326 27.4654C55.8074 26.2496 56.7173 24.9505 57.5296 23.5682L47.3254 5.44912C46.188 3.43403 44.092 2.18506 41.8011 2.18513L29.2578 2.18555C29.8102 2.60188 30.3464 3.03486 30.8826 3.46784C35.3346 7.28145 38.5519 12.1943 40.3718 17.5901Z"
        fill={`url(#${paint3})`}
        stroke="#284162"
      />
      <path
        d="M42.0703 27.1797C42.0703 27.3462 42.0703 27.5127 42.0872 27.6792C42.0872 27.5127 42.0703 27.3628 42.0703 27.1797Z"
        fill="#284162"
      />
      <defs>
        <linearGradient
          id={paint0}
          x1="22.4357"
          y1="2.16732"
          x2="22.4367"
          y2="31.9279"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="18.4089"
          y1="16.1069"
          x2="18.4102"
          y2="53.8447"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.2" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id={paint2}
          x1="39.4131"
          y1="23.5814"
          x2="39.4141"
          y2="53.8582"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.2" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id={paint3}
          x1="43.3934"
          y1="2.18508"
          x2="43.3946"
          y2="38.9736"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="white" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  )
}
